import { HTTP } from './helpers/http.js'

export default {
  add(organizationId, modelName, modelId) {
    const url = `/api/v1/organizations/${organizationId}/${modelName}/${modelId}/approvals`
    return HTTP.post(url)
  },

  remove(organizationId, modelName, modelId, approvalId) {
    const url = `/api/v1/organizations/${organizationId}/${modelName}/${modelId}/approvals/${approvalId}`
    return HTTP.delete(url)
  },
}
